import template from './template.html'
import module from 'contabilidad/catalogosexternos/module.js'

export class sucursalesListaItemComponent{
  item
  sucursalId
  expandido = false

  expandir(){
    this.expandido = true;
  }

  cerrar(){
    this.expandido = false;
  }
}

module.component('contabilidadCatalogosexternosSucursalesListaItem', {
  controller: sucursalesListaItemComponent,
  template,
  bindings: {
    sucursalId: '<',
    item: '<',
  }
})


// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/components/sucursales/lista/item/component.js